
const utils = require('../utils/misc');
const config = require('../config');
const templates = require('../templates');

function DrawingElement(id, setup) {
    this.id = id;
    this._setup = setup || this._setup;
}

DrawingElement.prototype.width = 100;
DrawingElement.prototype.ctx = null;
DrawingElement.prototype._setup = () => {};

DrawingElement.prototype.setup = function () {
    this.node = document.getElementById(this.id);
    if (!this.node) {
        console.warn(`DrawingElement "${this.id}" not found. It will not be drawn`);
        return;
    }
    this.buttonsNode = this.query('.buttons') || this.node;
    [this.width, this.ctx] = utils.setupCanvas(this.node);
    this.pad = this.width * config.paddingProportion;
    this._setup();
};

let radioId = 1;

DrawingElement.prototype.addRadioButtons = function (name, options) {
    const control = templates.getByName('radio-control').cloneNode(true);
    this.buttonsNode.appendChild(control);
    control.querySelector('.name').innerText = name;
    const radioName = `radio-${name.replace(/[^a-z]+/g, '-')}-${radioId++}`;
    const radioTemplate = templates.getByName('radio');
    return options.map((option) => {
        const radio = radioTemplate.cloneNode(true);
        control.appendChild(radio);
        radio.querySelector('.name').innerText = option.name || option.value;
        const radioInput = radio.querySelector('input');
        radioInput.name = radioName;
        radioInput.checked = !!option.checked;
        radioInput.value = option.value;
        return radioInput;
    });
};

DrawingElement.prototype.addLabeledCheckbox = function (label, checked) {
    const control = templates.getByName('labeled-checkbox').cloneNode(true);
    this.buttonsNode.appendChild(control);
    const input = control.querySelector('input');
    input.checked = !!checked;
    control.querySelector('.name').innerText = label;
    const description = control.querySelector('.value');
    return [input, description];
};

DrawingElement.prototype.addButton = function (buttonText) {
    const button = templates.getByName('simple-button').cloneNode(true);
    button.innerText = buttonText.toUpperCase();
    this.buttonsNode.appendChild(button);
    return button;
};

DrawingElement.prototype.addShapeSelector = function (min, max, selected) {
    const selectControl = templates.getByName('select').cloneNode(true);
    this.buttonsNode.appendChild(selectControl);
    const select = selectControl.querySelector('select');
    utils.fillWithShapeOptions(select, min, max, selected);
    return select;
};

DrawingElement.prototype.addLabeledSlider = function (label, min, max, current) {
    return utils.addLabeledSlider(this.buttonsNode, label, min, max, current);
};

DrawingElement.prototype.addToolbar = function (shape) {
    utils.addToolbar(this.node, this.ctx, shape);
};

DrawingElement.prototype.addRunButton = function (shape, limit) {
    utils.addRunButton(this.node, this.ctx, shape, limit);
};

DrawingElement.prototype.wipe = function () {
    this.ctx.clearRect(0, 0, this.width, this.width);
};

DrawingElement.prototype.query = function (query) {
    return this.node.querySelector(query);
};

DrawingElement.prototype.queryAll = function (query) {
    return this.node.querySelectorAll(query);
};

module.exports = DrawingElement;

